import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress } from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import AddInteriorItem from './AddInteriorItem'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import RemarksDynamicField from "../../../shared/components/RemarksDynamicField";
import { regexConstants } from "../../../constants/regEx";
import { assetTypeValues, backendDateFormat } from "../../../constants";
import { downloadFileType } from "../../../utils";
import { trackActivity } from "../../../utils/mixpanel";
import moment from "moment";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { arrayMoveImmutable } from "array-move";
import { mtInstance } from "../../../shared/components";

const galleyObj = {
    name: '',
    part_number: '',
    manufacturer: '',
    quantity: '',
    configuration: null,
    galley_type: null,
    location: null,
    remarks: ''
}
const GalleyHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '120px' }}>Action(s)</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Part Number</TableCell>
                <TableCell>Manufacturer</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Configuration</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>ATA Code</TableCell>
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}

const SortableBodyContainer = SortableContainer(({ galleysInfo, setAddEditGalley, setDeleteGalley }) => {
    return (
        <TableBody>
            {galleysInfo.list.map((item, index) =>
                <GalleyList
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index}
                    item={item}
                    onEdit={() => setAddEditGalley({ modal: true, data: item })}
                    onDelete={() => setDeleteGalley({ modal: true, data: item })}
                />
            )}
        </TableBody>
    );
});
const DragHandle = SortableHandle(() => <span style={{ paddingRight: '10px', display: 'inline-block', cursor: 'move', width: '10%' }}><DragIndicatorIcon /></span>);
const GalleyList = SortableElement(({ item, onEdit, onDelete }) => {
    return (
        <TableRow>
            <TableCell align="left" style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                <ul className="list-inline" style={{ width: '120px' }}>
                    {
                        checkPermission('technical_specs', 'interior', 'U') ?
                            <li className="list-inline-item hover-inline" onClick={onEdit}>
                                <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    {
                        checkPermission('technical_specs', 'interior', 'D') ?
                            <li className="list-inline-item hover-inline" onClick={onDelete}>
                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    <li className="list-inline-item hover-inline"><DragHandle /></li>
                </ul>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '180px' }}>{item?.name || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '120px' }}>{item?.part_number || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '180px' }}>{item?.manufacturer || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '100px' }}>{item?.quantity || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '120px' }}>{item?.configuration?.label || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '100px' }}>{item?.galley_type?.label || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '120px' }}>{item?.location?.label || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '120px' }}>{item?.ata_code || '--'}</div>
            </TableCell>
            <TableCell>
                <RemarksDynamicField
                    item={item}
                />
            </TableCell>
        </TableRow>
    )
})
const AddEditGalley = ({ params, addEditGalley, toggleModalFn, getResponseBack, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [galley, setGalley] = useState(addEditGalley.data);
    const [pltConstants, setPltConstants] = useState([]);
    const [error, setError] = useState({});
    useEffect(() => {
        globalPostService('console/get-constants/', { constant_types: ['galley_configuration', 'galley_type', 'interior_location'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }, [])
    const onFieldChange = (key, value) => {
        setGalley({ ...galley, [key]: value })
    }
    const onAddEditGalley = () => {
        let validationInputs = {
            name: galley?.name?.trim()?.length ? '' : 'Please enter Name',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            if (galley.id) {
                globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/interior/galley/${galley.id}/`, galley)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', { data:JSON.stringify(galley), page_title: 'Galley', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Galley data from Edit Galley form' })
                            toggleModalFn(); getResponseBack();

                        }
                        setLoading(false);
                    })
            } else {
                globalPostService(`console/v2/${params.type}/${params.aircraft_slug}/interior/galley/`, galley)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', { data:JSON.stringify(galley), page_title: 'Galley', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added Galley data from Add Galley form' })
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false);
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    return (
        <Dialog
            open={addEditGalley.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {galley.id ? 'Edit ' : 'Add '} Galley
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <TextField
                            required
                            name='name'
                            label='Name'
                            value={galley?.name || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('name', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 50 }}
                            error={error?.name}
                            helperText={error?.name || ''}
                            onFocus={() => setError({ ...error, 'name': '' })}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            name='part_number'
                            label='Part Number'
                            value={galley?.part_number || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('part_number', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 25 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            name='quantity'
                            label='Quantity'
                            value={galley?.quantity || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('quantity', e.target.value) : null}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 3 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <Autocomplete
                            options={!mtInstance ? pltConstants.filter(optionItem => optionItem.type === 'galley_configuration').filter(option=>option.value !==3):pltConstants.filter(optionItem => optionItem.type === 'galley_configuration')}
                            getOptionLabel={option => option.label}
                            name="configuration"
                            value={galley?.configuration || null}
                            onChange={(e, value) => onFieldChange('configuration', value)}
                            renderInput={params => <TextField {...params} label="Configuration" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <Autocomplete
                            options={pltConstants.filter(optionItem => optionItem.type === 'galley_type')}
                            getOptionLabel={option => option.label}
                            name="galley_type"
                            value={galley?.galley_type || null}
                            onChange={(e, value) => onFieldChange('galley_type', value)}
                            renderInput={params => <TextField {...params} label="Type" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <Autocomplete
                            options={pltConstants.filter(optionItem => optionItem.type === 'interior_location')}
                            getOptionLabel={option => option.label}
                            name="location"
                            value={galley?.location || null}
                            onChange={(e, value) => onFieldChange('location', value)}
                            renderInput={params => <TextField {...params} label="Location" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='manufacturer'
                            label='Manufacturer'
                            value={galley?.manufacturer || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('manufacturer', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 50 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='ata_code'
                            label='ATA Code'
                            value={galley?.ata_code || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('ata_code', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 25 }}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name='remarks'
                            label='Remarks'
                            value={galley?.remarks || ''}
                            fullWidth
                            margin="normal"
                            multiline
                            rows={3}
                            inputProps={{ maxLength: 250 }}
                            onChange={(e) => onFieldChange('remarks', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditGalley} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const Galley = ({ params, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [galleysInfo, setGalleysInfo] = useState({ list: [], pagination: null });
    const [addEditGalley, setAddEditGalley] = useState({ modal: false, data: null });
    const [deleteGalley, setDeleteGalley] = useState({ modal: false, data: null });
    useEffect(() => {
        getGalleys({per_page:50}, 'skeletonLoader');
    }, []);
    const getGalleys = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/interior/galley/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setGalleysInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteGalley = () => {
        setLoading(true);
        globalDeleteService(`console/v2/${params.type}/${params.aircraft_slug}/interior/galley/${deleteGalley.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteGalley({ modal: false, data: null })
                    getGalleys({per_page: galleysInfo?.pagination?.per_page}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    const onExportGallery = () => {
        setLoading(true);
        globalExportService(`console/v2/aircraft/${params.aircraft_slug}/interior/galley/?download=xlsx`)
            .then(response => {
                downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_galley ${moment().format(backendDateFormat)}`, 'xlsx')
                trackActivity('Console Management', { page_title: 'Galley', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Exported', event_desc: `Gallery Exported  Successfully`, file_extension: 'xlsx' })
                setLoading(false)
            });
    }
       const onSortEnd = ({ oldIndex, newIndex }) => {
            if (oldIndex !== newIndex) {
                let newArray = arrayMoveImmutable(galleysInfo?.list, oldIndex, newIndex)
                setLoading(true)
            setGalleysInfo({...galleysInfo, list:newArray})
                globalPutService(`console/v2/aircraft/${params.aircraft_slug}/interior/galley/reorder/`, { order_list: newArray.map(item => item.id) })
                    .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        }
                    })
            }
        }
    return (
        <div style={{ padding: '0px 10px' }}>
            {skeletonLoader ? <STableLoader count={8} size={7} /> :
                <>
                    <AddInteriorItem
                        addPermission={checkPermission('technical_specs', 'interior', 'C')}
                        exportPermission={checkPermission('technical_specs', 'interior', 'EXP')}
                        onAddItem={() => setAddEditGalley({ modal: true, data: galleyObj })}
                        item={galleysInfo}
                        isExport
                        isImport
                        onExport={() => onExportGallery()}
                        getResponseBack={() => getGalleys({}, 'skeletonLoader')}
                        expotrPermission={checkPermission('technical_specs', 'interior', 'EXP')}
                        trackActivity={trackActivity('Console Management', { page_title: 'Galley', event_type: 'Item Imported', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_desc: `Gallery Imported`, file_extension: 'xlsx' })}
                        url={`/console/v2/aircraft/${params.aircraft_slug}/interior/galley/import/`}
                    />
                    <Paper square>
                        <div style={{height:`${window.innerHeight -  (galleysInfo?.list?.length ? 330 : 280)}px`,overflow:'auto',marginTop: "3px" }}>
                        <Table className='mui-table-format' stickyHeader>
                            <GalleyHd />
                            <SortableBodyContainer
                                useDragHandle
                                onSortEnd={onSortEnd}
                                galleysInfo={galleysInfo}
                                setAddEditGalley={setAddEditGalley}
                                setDeleteGalley={setDeleteGalley}
                            />
                        </Table>
                        {!galleysInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    {galleysInfo?.pagination ?
                        <Paper square>
                            <Pagination
                                pagination={galleysInfo.pagination}
                                onChangePage={(event, newPage) => getGalleys({ ...filter, page: newPage + 1, per_page: galleysInfo.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getGalleys({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            /> </Paper>
                        : null
                    }
                </>
            }
            {addEditGalley.modal ?
                <AddEditGalley
                    params={params}
                    assetInfoData={assetInfoData}
                    addEditGalley={addEditGalley}
                    toggleModalFn={() => setAddEditGalley({ modal: false, data: null })}
                    getResponseBack={() => getGalleys({per_page: galleysInfo?.pagination?.per_page}, 'pageLoader')}
                /> : null
            }
            {deleteGalley.modal ?
                <DeletePopUp
                    modal={deleteGalley.modal}
                    title='Delete Galley'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteGalley({ modal: false, data: null })}
                    deleteRecordFn={onDeleteGalley}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(Galley);